import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Icon from 'components/icon/icon';
import 'components/action-modal/action-modal.scss';

class ActionModal extends React.Component {
    componentDidMount() {
        Modal.setAppElement('#root');
    }

    action(name) {
        this.props.closeModal(name);
    }

    render() {
        const { title, content, actions } = this.props;
        return (
            <Modal
                portalClassName="bk-action-modal"
                isOpen={this.props.isOpen}
                closeTimeoutMS={300}
                parentSelector={() => document.querySelector('#root')}
                className={{
                    base: 'bk-modal',
                    afterOpen: `bk-modal__after-open${this.props.isForUpgrade ? ` insight-upgrade` : ''}`,
                    beforeClose: 'bk-modal__before-close',
                }}
                overlayClassName={{
                    base: 'bk-modal-overlay',
                    afterOpen: 'bk-modal-overlay__after-open',
                    beforeClose: 'bk-modal-overlay__before-close',
                }}
                onRequestClose={this.props.closeModal}>
                <div className="bk-modal__title">
                    <Icon icon={this.props.icon || 'flag'} />
                    <h4>{title}</h4>
                    <span className="close" onClick={this.props.closeModal}>
                        <Icon icon="x" />
                    </span>
                </div>
                <div className="bk-modal__content">{content}</div>
                <div className="bk-modal__actions">
                    {actions.length > 0 &&
                        actions.map((action, i) => (
                            <button
                                key={`action-${i}`}
                                onClick={() => this.action(action.name)}
                                type="button"
                                className={`bk-button ${action.buttonClass}`}>
                                {action.name}
                            </button>
                        ))}
                </div>
            </Modal>
        );
    }
}

ActionModal.propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    content: PropTypes.node,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            buttonClass: PropTypes.string,
        }),
    ),
    title: PropTypes.string,
};

export default ActionModal;
